<template>
  <div id="header" v-if="!mobiTablet">
    <div class="container-fluid fill-height">
      <v-layout v-if="user" class="fill-height">
        <div
          class="d-flex justify-space-between align-center fill-height"
          style="width: 230px;"
        >
          <a href="/hotel/dashboard">
            <img
              class="logo"
              v-if="!logo"
              :src="!dataMain ? logoCrs : dataMain.logo"
              height="47px"
              alt
            />
            <img
              v-else-if="logo"
              :src="logo"
              class="logo"
              width="112px"
              height="47px"
              style="object-fit: contain"
              alt
            />
          </a>
          <v-icon color="#173d8f" v-on:click="toggleMenu">reorder</v-icon>
        </div>
        <div
          class="d-flex justify-space-between align-center pl-5 fill-height"
          style="width: calc( 100vw - 230px)"
        >
          <div class="title  d-flex align-items-center position-relative py-1">

           
            <v-menu offset-y :close-on-content-click="false" transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn v-bind="attrs" v-on="on" outlined class="pr-1" style="min-width: 400px; border: 1px solid #ccc">
                  <div class="d-flex justify-content-between w-100 align-items-center">
                    <div class="txt-long mr-auo text-primary fs-14" style="max-width: 350px; font-weight: 700 !important;">
                      {{ hotelMenuTitle }} - {{hotelCode}}
                    </div>
                    <i class="icon-keyboard_arrow_down fs-20"></i>
                  </div>
                </v-btn> -->
                <v-btn icon color="primary" class="mr-1" v-bind="attrs" v-on="on" :title="$t('_BOOKING.SEARCH')">
                  <i class="icon-Search" style="font-size: 30px;"></i>
                </v-btn>
                <div class="txt-long mr-auo text-primary fs-14" style="max-width: 350px; font-weight: 700 !important;">
                {{ hotelMenuTitle }} - {{hotelCode}}
              </div>
               
              </template>

              <v-card min-width="300">
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('ENTER_TO_SEARCH_MORE') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <b-form-input v-model="textSearch" @input="onSearchHotel(textSearch)" :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
                  </v-list-item>
                </v-list>
                <div>
                  <div v-for="(item, index) in hotels" :key="index" class="px-4">
                    <div class="d-flex w-100 align-items-start">
                      <div class="item py-1 flex-grow-1">
                        <div class="d-flex justify-content-between">
                          <span class="fs-12 font-weight-bold pr-3">{{ item.hotelI18n.find(e => e.lang === defaultI18n).name }}</span>
                          <span class="fs-12 text-primary">#{{ item.hotelCode }}</span>
                        </div>
                        <p class="fs-12 mb-0 text-secondary">{{ item.hotelI18n.find(e => e.lang === defaultI18n).address }}</p>
                      </div>
                      <div class="ml-3 py-1">
                        <v-btn outlined icon color="primary" class="delete app-link p-0" @click="useHotel(item)" x-small :title="$t('USE_HOTEL')">
                          <!-- {{
                            $t("USE_HOTEL")
                          }} -->
                          <!-- <v-icon left size="15" color="#173d8f">open_in_new</v-icon> -->
                          <i class="icon-arrow_outward"></i>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div class="px-4 py-3 text-center text-danger" v-if="hotels.length === 0">
                    {{ $t("NO_DATA") }}
                  </div>
                </div>
                <!-- <v-list class="pt-0" dense>
                  <v-list-item-group
                    color="primary"
                  >
                  <v-list-item style="max-height: 400px; overflow-y: auto" v-for="(item, index) in hotels" :key="index">
                  
                  </v-list-item>
                  </v-list-item-group>
                  <v-list-item v-if="hotels.length === 0">
                    {{ $t("NO_DATA") }}
                  </v-list-item>
                </v-list> -->
              </v-card>
            </v-menu>
          </div>
          <div class="d-flex">
            <div class="menu div-process" @click="showDialogHotelStatus = true">
              <div>
                <p class="m-0 p-complete">
                  <b>{{ $t("COMPLETE_INFOMATION") }}</b>
                  <b class="b-percen">{{ process }}/7</b>
                </p>
                <p class="m-0">
                  <b-progress :value="process" :max="7"></b-progress>
                </p>
              </div>
            </div>
            <div class="menu">
              <a class="notification">
                <v-icon class="text-primary">notifications</v-icon>
                <b-badge
                  variant="danger"
                  class="badge"
                  v-if="quantityNotice > 0"
                  >{{ quantityNotice }}</b-badge
                >
                <b-badge variant="danger" class="badge"></b-badge>
              </a>
              <ul class="container-notice">
                <div class="card-item notice">
                  <div
                    class="card-item-header d-flex justify-content-between align-items-center header-notice"
                  >
                    <label
                      slot="header"
                      class="card-item-title title-bandage"
                      >{{ $t("NOTIFICATION") }}</label
                    >
                    <a
                      class="set-seen"
                      style="padding-right: 10px; font-size: 12px !important;"
                      @click="showMore"
                      >{{ $t("SHOW_MORE") }}</a
                    >
                    <a
                      class="set-seen"
                      style="padding-right: 10px; font-size: 12px !important;"
                      @click="setSeenAllNotice"
                      >{{ $t("MARK_AS_READ") }}</a
                    >
                  </div>
                  <div
                    class="card-item-content no-padding content-notification"
                    style="padding-bottom: 14px;"
                  >
                    <template>
                      <div v-if="listNotice.length > 0">
                        <div
                          @click="setSeenNotice(item)"
                          class="notification-item"
                          v-for="item of listNotice"
                          :key="item['.key']"
                          :class="
                            item.seen === false
                              ? 'bg-unseen notice'
                              : 'bg-seen notice'
                          "
                        >
                          <div class="item d-flex align-start flex-column">
                            <div class="notification-item-title w-100">
                              <span class="notification-item-text">{{
                                $t(item.title)
                              }}</span>
                              <span class="notification-item-time badge-is-new">
                                {{ item.date }}
                                <span
                                  :class="
                                    item.seen === false ? 'badge-is-new' : ' '
                                  "
                                ></span>
                              </span>
                            </div>
                            <div class="notification-item-content mb-auto text-truncate w-90">{{
                              item.content.content
                            }}</div>
                            <div class="notice-item-booking">
                              <p class="align-self-end mb-0 text-secondary">
                                {{$t('_BOOKING.BOOKING_CODE')}}: <b>{{ item.booking.code }}</b>
                              </p>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </div>
                      <div v-else>
                        <p class="no-notice">{{ $t("NO_NOTIFICATION") }}</p>
                      </div>
                    </template>
                  </div>
                </div>
              </ul>
            </div>
            <div class="menu" v-if="!dataMain || (dataMain && dataMain.linkHelp !== '')">
              <a class="notification" :href="!dataMain ? 'https://help.ezcms.vn' : dataMain.linkHelp" target="_blank">
                <v-icon class="text-primary">help</v-icon>
              </a>
            </div>
            <div class="menu">
              <img
                :src="languageUrl"
                width="24"
                height="24"
                alt="vi"
                class="lang"
              />
              
              <ul class="language font-weight-normal">
                <li
                  v-for="(lang, index) in languageList"
                  :key="`languageList_${index}`"
                  class="d-flex align-center cursor"
                  @click="changeLanguage(lang.languageCode)"
                >
                  <span>
                    <img
                      :src="`https://static.oneinventory.com${lang.flagUrl}`"
                      width="24"
                      height="24"
                      alt
                    />
                  </span>
                  <span>{{ lang.name }}</span>
                </li>
              </ul>
            </div>
            <div class="menu" @click="changeDrawer()">
              <img
                class="avatar"
                v-if="!user.avatar"
                src="@/assets/svg/account-circle.svg"
                alt
              />
              <img class="avatar" v-else :src="user.avatar" alt />
              <div class="d-flex flex-column ml-3">
                <span class="txt-long">{{ user.fullName }}</span>
                <span class="user-group txt-long">{{ user.group }}</span>
              </div>
              <!-- <ul>
                <li
                  class="d-flex align-center cursor"
                  @click="goToPersonalSetting"
                >
                  <span class="icon icon-Account"></span>
                  <span>{{ $t("PERSONAL_ACCOUNT_SETTING") }}</span>
                </li>
                <li class="d-flex align-center cursor" @click="logout">
                  <span class="icon icon-Logout"></span>
                  <span>{{ $t("LOG_OUT") }}</span>
                </li>
                <li class="d-flex align-center cursor" @click="changeDevice()" v-if="isMobiTablet && !mobiTablet">
                  <v-icon class="icon mr-3 text-primary">desktop_access_disabled</v-icon>
                  <span>{{ $t("VIEW_MOBILE_VERSION") }}</span>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </v-layout>
    </div>
    <v-dialog
      v-if="hotelStatus !== null"
      v-model="showDialogHotelStatus"
      max-width="700"
      content-class="dialog-confirm"
    >
      <div class="card-item" style="border-radius: 4px;">
        <div class="card-item-header">
          <label slot="header" class="card-item-title">{{
            $t("_DASHBOARD.MISSING_INFO.TITLE")
          }}</label>
        </div>
        <div class="card-item-content">
          <table class="w-100">
            <tbody>
              <tr>
                <!-- Hotel info -->
                <td class="w-40">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelInfo" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToHotelInfo"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.HOTEL_INFO") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.HOTEL_INFO_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
                <!-- Room info -->
                <td class="pt-2 w-60">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelPlan" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToSalePackage"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.ROOM_PLAN") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.ROOM_PLAN_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <!-- Hotel image -->
                <td class="pt-2 w-40">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelPicture" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToHotelImage"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.HOTEL_IMAGE") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.HOTEL_IMAGE_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
                <!-- Room plan -->
                <td class="pt-2 w-60">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelRoomSale" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToRoomSale"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.RATE_PLAN") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.RATE_PLAN_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <!-- Hotel config -->
                <td class="pt-2 w-40">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelSetting" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToHotelConfig"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.HOTEL_CONFIG") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.HOTEL_CONFIG_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
                <!-- Cancel policy -->
                <td class="pt-2 w-60">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelSyncOta" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToSyncOTA"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.SYNC_OTA") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.SYNC_OTA_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <!-- Payment policy -->
                <td class="pt-2 w-40">
                  <div class="d-flex flex-row align-items-center">
                    <v-icon v-if="hotelStatus.hotelRoom" color="#173d8f"
                      >done</v-icon
                    >
                    <v-icon v-else color="#f8ad00">info</v-icon>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex align-items-center">
                        <a
                          @click="goToRoomInfo"
                          href="javascript:;"
                          class="hotel-info-link"
                          >{{ $t("_DASHBOARD.MISSING_INFO.ROOM_TYPE") }}</a
                        >
                        <v-icon small color="#173d8f" class="ml-2"
                          >arrow_forward</v-icon
                        >
                      </div>
                      <span class="hotel-info-subtitle d-block">{{
                        $t("_DASHBOARD.MISSING_INFO.ROOM_TYPE_SUB_TITLE")
                      }}</span>
                    </div>
                  </div>
                </td>
                <td class="pt-2 w-60"></td>
              </tr>
            </tbody>
          </table>
          <v-row>
            <v-col class="btn-right-wrapper text-right">
              <!-- <v-btn color="red text-light" class="mr-3" v-if="complete"  @click="confirmHotelInfo">{{$t('CONFIRM')}}</v-btn> -->
              <v-btn
                color="primary"
                class="pl-5 pr-5"
                @click="showDialogHotelStatus = false"
                >{{ $t("_DASHBOARD.MISSING_INFO.CLOSE") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
    </v-dialog>
  </div>
  <div id="header-mobile" v-else>
    <div class="container-fluid fill-height">
      <v-layout v-if="user" class="fill-height d-flex justify-content-start align-items-center">
        <div class="d-flex align-center fill-height">
          <a href="/booking/list-booking">
            <img
              class="logo"
              v-if="!logo"
              :src="!dataMain ? logoCrs : dataMain.logo"
              height="30px"
              alt
            />
            <img
              v-else
              :src="logo"
              class="logo"
              height="30px"
              style="object-fit: contain"
              alt
            />
          </a>
        </div>
        <div class="fs-15 ml-3 d-flex" style="flex-grow: 2"> 
          <marquee v-if="hotelMenuTitle.length >= 30 && !tablet"><strong>{{hotelMenuTitle}}</strong></marquee>
            <strong v-else>{{hotelMenuTitle}}</strong>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.notification-item {
  padding: 0px 20px;
  cursor: pointer;
  &:hover {
    background-color: #ced4da;
  }
  .notification-item-title {
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .notification-item-text {
      font-size: 14px;
      color: #262626;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .notification-item-time {
      position: relative;
      padding-left: 20px;
      font-size: 12px !important;
      line-height: 2;
      text-align: right;
      color: #808080;
      &.badge-is-new {
        margin-right: 10px;
      }
      .badge-is-new {
        position: absolute;
        font-size: 12px !important;
        display: block;
        top: 7px;
        right: -14px;
        width: 8px;
        height: 8px;
        padding: 0;
        border-radius: 50%;
        background: #d9390d;
      }
    }
  }
  .notification-item-content {
    font-size: 12px !important;
    color: #808080;
  }
  hr {
    margin-top: 5px;
    margin-bottom: 0px;
  }
}

.div-process {
  padding-right: 25px;
  padding-left: 25px;
  .p-complete {
    color: rgba(38, 38, 38, 0.5);
    .b-percen {
      color: #00a0dc;
      position: absolute;
      right: 25px;
    }
  }
  .progress {
    width: 215px;
    height: 10px;
  }
}
.div-process:hover {
  background: rgba(232, 245, 251, 0.5);
  cursor: pointer;
}
</style>

<script>
const hotelTitleMaxlength = 50;
const usernameMaxlength = 20;
import { authenticationService } from "@/_services";
import { _storedUserInfo } from "@/_helpers/function.js";
import eventBus from "@/_helpers/event-bus.js";
import { service } from "@/_services/Account/Setting/account-setting.service.js";
import { notificationService } from "@/_services/notification.service.js";
import firebase from "@/_helpers/firebaseConfig.js";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";

import { CoolSelect } from 'vue-cool-select';
import logoCrs from '@/assets/ezCrs-ngang.png';
import { service as generalSetting } from "@/_services/HotelSetting/general-setting.service.js";

export default {
  components: {
    CoolSelect 
  },
  data() {
    return {
      logoCrs: logoCrs,
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      sysLang: this.$i18n.locale,
      logo: null,
      user: null,
      hotelMenuTitle: null,
      hotelName: null,
      hotelCode: null,
      showMenuNotifications: false,
      list: [],
      quantity: 0,
      origTitle: document.title,
      loadNotice: 0,
      userLogin: JSON.parse(localStorage.getItem("currentUser")).user.id,
      showDialogHotelStatus: false,
      isShow: null,
      hotelStatus: null,
      process: 0,
      hideSidebar: JSON.parse(localStorage.getItem("hideSidebar")),
      timeZone: localStorage.getItem("GMT"),
      systemLang: this.$i18n.locale,
      selectedHotel: null,
      hotels: [],
      loadingSearch: false,
      showInput: false,
      noData: false,
      textSearch: "",
      languageList: JSON.parse(localStorage.getItem("listI18ns") || '[]')
    };
  },
  mounted() {
    if (!localStorage.getItem('listI18ns')) {
      this.getLanguageList();
    }
    var restoreId = this.currentUser.user.chatId;
    var init = {
      firstName: this.currentUser.user.fullName,
      email: this.currentUser.user.email,
      phone: this.currentUser.user.phone,
      locale: this.sysLang,
      HotelId: this.currentUser.hotel.id,
      HotelName: this.currentUser.hotel.i18ns.find(
        x => x.lang == this.defaultI18n
      ).name,
      Product: "ezCms"
    };
    // if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || this.domain == "localhost") {

      window.ChatBoxWidget.user.setProperties({
        token: process.env.VUE_APP_CHATBOX_CUSTOMER_TOKEN,
        lang: this.sysLang,
        externalId: this.currentUser.user.email,
        userProperties: {
          firstName: this.currentUser.user.fullName,
          lastName: '',
          email: this.currentUser.user.email,
          avatarUrl: this.currentUser.user.avatar,
          phone: this.currentUser.user.phone,
        },
        customFields: {
          LOCATION: null,
          HOTELID: this.currentUser.hotel.hotelCode,
          HOTELNAME: this.currentUser.hotel.i18ns.find(
            x => x.lang == this.sysLang
          ).name,
          PHONE: this.currentUser.user.phone,
          USERNAME: this.currentUser.user.username,
          EMAIL: this.currentUser.user.email,
          URL: window.location.href
        },
        position: 'left'
      });
    // }
    
  },

  created() {
    this.reloadCurrentUser();
    this.onSearchHotel("");
    eventBus.$on("EVENT_RELOAD_USER", () => this.reloadCurrentUser());
    if (
      this.$route.name != "chain-list" &&
      this.$route.name != "booking-list"
    ) {
      this.getProcess();
      eventBus.$on("EVENT_RELOAD_PROCESS", e => {
        this.getProcess();
      });
    }
    this.isShow = JSON.parse(localStorage.getItem("hotelStatus"));
    this.listNotifi();
  },
  computed: {
    languageUrl() {
      return require(`@/assets/flags/${this.$i18n.locale}.png`);
    },
    status: {
      get() {
        return this.isShow || null;
      },
      set(value) {
        this.isShow = value;
      }
    },
    isShowProcess() {
      try {
        return this.status.information === "WAIT_CONFIRM";
      } catch (e) {
        return false;
      }
    },
    complete() {
      let isInfoComplete = true;
      for (const key of Object.keys(this.hotelStatus)) {
        if (!this.hotelStatus[key]) {
          isInfoComplete = false;
          break;
        }
      }
      if (isInfoComplete) {
        return true;
      }
      return false;
    },
    // re turn list notice to display for user
    listNotice() {
      const array = [];
      this.list.forEach(e => {
        array.push(e);
      });
      return array;
    },
    // display quantity of new notice not seen
    quantityNotice() {
      this.quantity = 0;
      this.list.forEach(e => {
        if (e.seen === false) {
          this.quantity++;
        }
      });
      return this.quantity;
    }
  },
  methods: {
    async getLanguageList() {
      await generalSetting.getLangs().then(res => {
        if (res.responseCode == 0) {
          this.languageList = res.data;
          localStorage.setItem("listI18ns", JSON.stringify(res.data));
        }
      });
    },
    onSearchHotel(val) {
      clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
        let body = {};
        body.keyword = val;
        body.status = null;
        body.limit = 5;
        body.offset = 0;
        this.loadingSearch = true;
        this.noData = false;
        chainService
          .get(body)
          .then(res => {
            if (res.data.length > 0) {
              const hid = this.$route.params.hotelIdParam;
              this.hotels = res.data.filter(h => h.id !== hid);
            } else {
              this.hotels = []
            }
            
            if (this.hotels.length <= 0) this.noData = true;
          })
          .finally(() => (this.loadingSearch = false));
			}, 500);
    },
    updatePathParams(newParams) {

      // Retrieve current params
      const currentParams = this.$router.currentRoute.params;

      // Create new params object
      const mergedParams = { ...currentParams, newParams };
      console.log(mergedParams)

      // When router is not supplied path or name,
      // it simply tries to update current route with new params or query
      // Almost everything is optional.
      this.$router.push({ params: mergedParams.newParams });
      window.location.reload();
    },
    useHotel(item) {
       this.$session.set("ojbBooking", null);
      chainService.useHotel(item.id).then(res => {
        if (res.responseCode != 0) {
          return false;
        }
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("currentUser", JSON.stringify(res.data));
        localStorage.setItem("jwt", res.data.token);
        localStorage.setItem("showmenuchain", JSON.stringify(true));
        localStorage.setItem(`${res.data.hotel.id}-beLink`, res.data.hotel.beLink);
        localStorage.setItem("defaultLanguage", res.data.hotel.defaultLanguage);

        let gmt = null;
        let timeZoneStr = null;
        this.optionUTC.forEach(item => {
          item.children.forEach(child => {
            if (child.id === res.data.hotel.timeZoneStr) {
              localStorage.setItem("timeZoneStr", res.data.hotel.timeZoneStr);
              localStorage.setItem("GMT", child.label);
              gmt = child.label;
              timeZoneStr = res.data.hotel.timeZoneStr;
              return;
            }
          })
        })
        const localArrToken = localStorage.getItem("arrToken") ? JSON.parse(localStorage.getItem("arrToken")) : [];
          if (localArrToken && localArrToken.length > 0) {
              const arr = localArrToken.filter(e => e.hotel == null || e.hotel.id !== item.id);
              arr.push({
                hotel: res.data.hotel,
                token: res.data.token,
                usedCurrency: item.usedCurrency,
                gmt: gmt,
                timeZoneStr: timeZoneStr,
              });
              localStorage.setItem("arrToken", JSON.stringify(arr));
          } else {
              localArrToken.push({
                hotel: res.data.hotel,
                token: res.data.token,
                usedCurrency: item.usedCurrency,
                gmt: gmt,
                timeZoneStr: timeZoneStr,
              });
              localStorage.setItem("arrToken", JSON.stringify(localArrToken));
          }
        if (!this.mobiTablet) {
          this.updatePathParams({ hotelIdParam: res.data.hotel.id });
        } else {
          _alert(res, this.$t('HOTEL_CHANGE_SUCCESS'), false);
        }
      });
    },
    async getAllOTA() {
      let listOtaConnect = [];
      await syncota.getAllOTA({ keyword: "", status: 1 }).then(res => {
        if (res.responseCode === 0) {
          res.data.forEach(x => {
            listOtaConnect.push({
              value: x.otaCode,
              text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
            });
          });
          localStorage.setItem("listOtaConnect", JSON.stringify(listOtaConnect));
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    changeDrawer() {
      this.$emit('changeDrawerAplication')
    },
    changeDevice() {
      localStorage.setItem("device", 'MOBILE');
      this.$router.push({ name: "chain-dashboard" });
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    toggleMenu() {
      if (this.hideSidebar) {
        this.hideSidebar = false;
        localStorage.setItem("hideSidebar", false);
        document.getElementById("nav-wrapper").classList.remove("hide-sidebar");
        document
          .getElementById("main-wrapper")
          .classList.remove("hide-sidebar");
      } else {
        this.hideSidebar = true;
        localStorage.setItem("hideSidebar", true);
        document.getElementById("nav-wrapper").classList.add("hide-sidebar");
        document.getElementById("main-wrapper").classList.add("hide-sidebar");
      }
      eventBus.$emit("EVENT_RELOAD_SIDEBAR");
      eventBus.$emit("EVENT_RELOAD_SIDEBAR_MAIN");
    },
    getProcess() {
      service.getInfoStatus().then(res => {
        if (res.responseCode === 0) {
          this.hotelStatus = res.data;
          this.process = Object.values(res.data).filter(e => e === true).length;
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get("shownoti") === "1") {
            this.showDialogHotelStatus = true;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    confirmHotelInfo() {
      this.isLoading = true;
      service
        .confirmHotelInfo()
        .then(res => {
          _alert(res, this.$t(res.data), false);
          this.showDialogHotelStatus = false;
        })
        .finally(() => (this.isLoading = false));
    },
    goToRoomSale() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "roomSale" });
    },
    goToHotelInfo() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "registerInfomation" });
    },
    goToRoomInfo() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "roomInfo" });
    },
    goToHotelImage() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "hotelImages" });
    },
    goToSalePackage() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "listOfSalePackages" });
    },
    goToSyncOTA() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "aliasOTA" });
    },
    goToHotelConfig() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "generalSetting" });
    },
    goToRoomCancel() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "cancellationPolicy" });
    },
    goToPaymentGate() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "payGate" });
    },
    goToContract() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "contract" });
    },
    goToPaymentPolicy() {
      this.showDialogHotelStatus = false;
      this.$router.push({ name: "paymentPolicy" });
    },
    logout() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
     this.$oidc.signoutRedirect();
      authenticationService.logout();
      this.$router.push({ name: "login" });
      // }
      location.reload();
    },
    goToPersonalSetting() {
      this.$router.push({ name: "accountSetting" });
    },
    changeLanguage(lang) {
      localStorage.setItem("systemLanguage", lang);
      location.reload();
    },
    async reloadCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      const queryString = window.location.href;
      let hotel =  JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      await service.getProfile().then(res => {
        let newUser = res.data;
        hotel.usedCurrency = res.data.currency;
        const localArrToken = localStorage.getItem("arrToken") ? JSON.parse(localStorage.getItem("arrToken")) : [];
        const arr = localArrToken.filter(e => e.hotel == null || e.hotel.id !== hotel.hotel.id);
        arr.push(hotel);
        localStorage.setItem("arrToken", JSON.stringify(arr));
        if (currentUser && currentUser.user && newUser) {
          if (
            this.$route.name != "chain-list" &&
            this.$route.name != "booking-list"
          ) {
            this.logo = hotel.hotel.logo;
          }
          if (
            this.$route.name != "chain-list" &&
            this.$route.name != "booking-list"
          ) {
            this.hotelName =  hotel.hotel.i18ns.find(
              x => x.lang == this.defaultI18n
            ).name;
            this.hotelMenuTitle = hotel.hotel.i18ns.find(
              x => x.lang == this.defaultI18n
            ).name;
            if (this.hotelMenuTitle.length > hotelTitleMaxlength && !this.mobiTablet) {
              this.hotelMenuTitle =
                this.hotelMenuTitle.slice(0, hotelTitleMaxlength) + " ...";
            }
            this.hotelCode = hotel.hotel.hotelCode;
          }
          currentUser.user.avatar = newUser.avatar;
          currentUser.user.fullName = newUser.fullName;
          if (currentUser.user.fullName.length > usernameMaxlength) {
            currentUser.user.fullName =
              currentUser.user.fullName.slice(0, usernameMaxlength) + " ...";
          }
          currentUser.user.group = newUser.userGroup;
          this.user = Object.assign({}, this.user, currentUser.user);
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          localStorage.setItem("hotelSync", JSON.stringify(res.data.hotelSync));
          localStorage.setItem(
            "hotelWeekend",
            JSON.stringify(res.data.hotelWeekend)
          );
          localStorage.setItem("currency", JSON.stringify(res.data.currency));
          const currencys = JSON.parse(localStorage.getItem('currencys'));
          localStorage.setItem("symbol", currencys.find(e => e.code === res.data.currency) ? currencys.find(e => e.code === res.data.currency).symbol : null);
          const localArrToken = localStorage.getItem("arrToken") ? JSON.parse(localStorage.getItem("arrToken")) : [];
          if (localArrToken && localArrToken.length > 0) {
              localArrToken.forEach(e => {
                if (e.hotel && e.hotel.id 
                === 
                hotel.hotel.id) {
                  e.hotel.currency = res.data.currency
                  e.hotel.symbol = currencys.find(e => e.code === res.data.currency) ? currencys.find(e => e.code === res.data.currency).symbol : null
                }
              })
              localStorage.setItem("arrToken", JSON.stringify(localArrToken));
          }
        }
        this.getAllOTA();
      });
    },
    // set seen for all notice
    setSeenAllNotice() {
      const noticeId = [];
      this.list.forEach(temp => {
        if (temp.seen === false) {
          noticeId.push(temp.key);
        }
      });
      // this.changeTitle();
      document.title = this.origTitle;
      if (noticeId.length === 0) return;
      notificationService.seenNotice(noticeId);
    }, // set seen for current notice click
    setSeenNotice(item) {
      const noticeId = [];
      this.list.forEach(temp => {
        if (temp.key === item.key) {
          if (temp.seen === false) {
            noticeId.push(temp.key);
          }
        }
      });
      notificationService.seenNotice(noticeId);
      // this.changeTitle();
      this.opennewwin(item.link)
      this.quantity = 0;
    },
    timeSince(date) {
      const seconds = Math.floor((new Date() - date) / 1000);

      let interval = Math.floor(seconds / 31536000);

      if (interval >= 1) {
        return `${interval} ${this.$t("YEARS")} ${this.$t("AGO")}`;
      }
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        return `${interval} ${this.$t("MONTHS")} ${this.$t("AGO")}`;
      }
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) {
        return `${interval} ${this.$t("DAYS")} ${this.$t("AGO")}`;
      }
      interval = Math.floor(seconds / 3600);
      if (interval >= 1) {
        return `${interval} ${this.$t("HOURS")} ${this.$t("AGO")}`;
      }
      interval = Math.floor(seconds / 60);
      if (interval >= 1) {
        return `${interval} ${this.$t("MINUTES")} ${this.$t("AGO")}`;
      }
      if (seconds <= 10) {
        return `${this.$t("NOW")}`;
      }
      return `${Math.floor(seconds)} ${this.$t("SECONDS")} ${this.$t("AGO")}`;
    },
    opennewwin(link){
        var awindow = window.open(link, "_blank");
    },
    // get all notice from firebase
    listNotifi() {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      if (!currentUser.user.roles.find((role) => role.fnCode === "MES")) return;
      const array = [];
      this.loadMoreNotice();
      const queryString = window.location.href;
      let hotel =  JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      console.log('fire', `/Notifications/Message/User-${this.userLogin}/Hotel-${hotel.hotel.hotelCode}`)
      firebase
        .ref(`/Notifications/Hotel/User-${this.userLogin}/Hotel-${hotel.hotel.hotelCode}`)
        // .orderByChild(`Hotel-${hotel.hotel.hotelCode}`)
        .limitToLast(this.loadNotice)
        .on("value", snapshot => {
          array.splice(0, array.length);
          snapshot.forEach(childSnapshot => {
            const item = childSnapshot.val();
            item.key = childSnapshot.key;
            // if (this.$store.getters.currentLanguage.code === 'vi') {
            // item.contentLang = item.content.vi;
            // } else {
            // item.contentLang = item.content.en;
            // }
            item.date = `${this.timeSince(item.createdDate.time)}`;
            item.link = `${process.env.VUE_APP_EZ_MESSAGE_BASE_URL}/apps/chat?id=${item.content.id}`;
            array.push(item);
          });
          array.sort(
            (a, b) =>
              new Date(b.createdDate.time) - new Date(a.createdDate.time)
          );
          this.list = [...array];
          // this.changeTitle();
          // if (array[0].seen === false) {
          //   if (
          //     this.$store.getters["user/accessToken"] !== "" &&
          //     new Date().getTime() - array[0].createdDate.time <= 60000 &&
          //     array[0].username === this.userLogin
          //   ) {
          //     this.$bvToast.toast(`${array[0].contentShow}`, {
          //       title: this.$t(array[0].title),
          //       variant: "info"
          //     });
          //   }
          // }
        });
      // this.$eventHub.$emit('noticeLength', array);
    },
    changeTitle() {
      let title = document.title;
      let notifications = 0;
      // this regex will test if the document title already has a notification count in it, e.g. (1) My Document
      if (/\([\d]+\)/.test(title) && this.quantityNotice > 0) {
        // we will split the title after the first bracket
        title = title.split(") ");
        document.title = "(" + this.quantityNotice + ") " + title[1];
      } else if (this.quantityNotice === 0) {
        document.title = this.origTitle;
      }
      // when the current document title does not contain any notification count, just update it
      else {
        document.title = "(" + this.quantityNotice + ") " + title;
      }
    },
    // expand to see more notice
    loadMoreNotice() {
      this.loadNotice = this.loadNotice + 5;
    },
    showMore() {
      this.listNotifi();
    }
  },
  watch: {
    selectedHotel(val) {
      this.useHotel(this.hotels[val]);
    },
    currentUser: {
      handler(newVal) {
        const trySetProperties = () => {
          if (
            window.ChatBoxWidget &&
            typeof window.ChatBoxWidget.isLoaded === 'function' &&
            window.ChatBoxWidget.isLoaded()
          ) {
            window.ChatBoxWidget.user.setProperties({
              token: process.env.VUE_APP_CHATBOX_CUSTOMER_TOKEN,
              lang: this.sysLang,
              externalId: this.currentUser.user.email,
              userProperties: {
                firstName: this.currentUser.user.fullName,
                lastName: '',
                email: this.currentUser.user.email,
                avatarUrl: this.currentUser.user.avatar,
                phone: this.currentUser.user.phone,
              },
              customFields: {
                LOCATION: null,
                HOTELID: this.currentUser.hotel.hotelCode,
                HOTELNAME: this.currentUser.hotel.i18ns.find(
                  x => x.lang == this.sysLang
                ).name,
                PHONE: this.currentUser.user.phone,
                USERNAME: this.currentUser.user.username,
                EMAIL: this.currentUser.user.email,
                URL: window.location.href
              },
              position: 'left'
            });
          } 
          else {
            setTimeout(trySetProperties, 100);
          }
        };
        trySetProperties();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
